module.exports = __webpack_public_path__ + "img/kommune-1149.fd57cc9d.svg";